'use client'

import { useState } from 'react'
import Link from 'next/link'
import config from '../../data/site-config.json'
import { trackPhoneClick } from '../../lib/analytics'
import AvailabilityBadge from '../common/AvailabilityBadge'

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <header style={{
            background: 'var(--white)',
            boxShadow: 'var(--shadow)',
            position: 'sticky',
            top: 0,
            zIndex: 1000
        }}>
            <div className="container" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.7rem var(--spacing-sm)',
                flexWrap: 'nowrap',
                gap: 'var(--spacing-sm)'
            }}>
                <Link href="/" style={{ fontSize: '1.05rem', fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--primary)', whiteSpace: 'nowrap', flexShrink: 0 }}>
                    {config.business.shortName || 'CFC Perth'}
                </Link>

                {/* Mobile Menu Button */}
                <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="show-mobile"
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                        padding: '0.5rem',
                        color: 'var(--gray-800)'
                    }}
                    aria-label="Toggle menu"
                >
                    {isMenuOpen ? '✕' : '☰'}
                </button>

                {/* Desktop Navigation */}
                <nav className="hide-mobile" style={{ display: 'flex', gap: '0.9rem', alignItems: 'center' }}>
                    {[
                        { href: '/services', label: 'Services' },
                        { href: '/areas', label: 'Areas' },
                        { href: '/faq', label: 'FAQ' },
                        { href: '/blog', label: 'Blog' },
                        { href: '/about', label: 'About' },
                        { href: '/contact', label: 'Contact' },
                    ].map(link => (
                        <Link
                            key={link.href}
                            href={link.href}
                            style={{
                                fontWeight: 600,
                                fontSize: '0.95rem',
                                color: 'var(--gray-600)',
                                textDecoration: 'none',
                                padding: '0.35rem 0',
                                borderBottom: '2px solid transparent'
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.color = 'var(--primary)'
                                e.currentTarget.style.borderBottomColor = 'var(--secondary)'
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.color = 'var(--gray-600)'
                                e.currentTarget.style.borderBottomColor = 'transparent'
                            }}
                        >
                            {link.label}
                        </Link>
                    ))}
                    <Link href="/quote" className="btn btn-secondary" style={{ padding: '0.6rem 1.2rem', fontSize: '0.92rem' }}>Get Quote</Link>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.25rem' }}>
                        <Link
                            href={`tel:${config.business.phone}`}
                            onClick={() => trackPhoneClick('header')}
                            className="btn btn-primary"
                            style={{ padding: '0.6rem 1.2rem', fontSize: '0.95rem', whiteSpace: 'nowrap' }}
                        >
                            📞 {config.business.phone}
                        </Link>
                        <AvailabilityBadge size="sm" />
                    </div>
                </nav>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
                <div className="container show-mobile" style={{
                    background: 'var(--white)',
                    paddingBottom: 'var(--spacing-sm)',
                    boxShadow: 'var(--shadow-md)'
                }}>
                    <nav style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.15rem',
                        padding: 'var(--spacing-sm) 0 0',
                        borderTop: '1px solid var(--gray-200)',
                        marginTop: 'var(--spacing-xs)'
                    }}>
                        {[
                            { href: '/services', label: 'Services' },
                            { href: '/areas', label: 'Areas' },
                            { href: '/faq', label: 'FAQ' },
                            { href: '/blog', label: 'Blog' },
                            { href: '/about', label: 'About' },
                            { href: '/contact', label: 'Contact' },
                        ].map(link => (
                            <Link
                                key={link.href}
                                href={link.href}
                                onClick={() => setIsMenuOpen(false)}
                                style={{
                                    padding: '0.7rem 0.5rem',
                                    color: 'var(--gray-700)',
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    borderRadius: 'var(--radius-sm)'
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.background = 'var(--primary-soft)'
                                    e.currentTarget.style.color = 'var(--primary)'
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.background = 'transparent'
                                    e.currentTarget.style.color = 'var(--gray-700)'
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.6rem', margin: '0.75rem 0 0.5rem' }}>
                            <Link href="/quote" onClick={() => setIsMenuOpen(false)} className="btn btn-secondary" style={{ textAlign: 'center' }}>💰 Get Quote</Link>
                            <Link
                                href={`tel:${config.business.phone}`}
                                onClick={() => { setIsMenuOpen(false); trackPhoneClick('header_mobile') }}
                                className="btn btn-primary"
                                style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                            >
                                📞 {config.business.phone}
                            </Link>
                        </div>
                        <div style={{ paddingBottom: '0.35rem' }}>
                            <AvailabilityBadge size="sm" />
                        </div>
                    </nav>
                </div>
            )}
        </header>
    )
}
